import BossModel from "@/models/BossModel";

export default class WebsiteHighlight extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-highlight';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteHighlights';

    static fields() {
        return {
            id: this.number(null).nullable(),
            title: this.attr(null),
            description: this.attr(null).nullable(),
        }
    }
}
